@if (!sidebar) {
  <app-looker-studio-navigation (sizeChanged)="widthRatio = $event.value"></app-looker-studio-navigation>
}

<div
  class="mx-auto"
  style="padding: 5px {{ sidebar ? '0' : '60px' }}; max-width: {{ 95 * (sidebar ? 1 : widthRatio) }}vw"
>
  <div
    class="d-flex flex-row align-items-start justify-content-between mt-{{ sidebar ? 0 : 5 }}"
    [ngClass]="sidebar ? 'sticky-sidebar' : 'sticky-header'"
  >
    <div class="header-spacer"></div>

    <h2 class="h2 text-center mb-0">
      <span class="d-inline-flex align-items-center">
        <app-vficon
          class="clickable"
          style="position: relative; bottom: 3px"
          iconPack="source-tobi-icons"
          iconName="default"
        ></app-vficon>
        <span class="ms-2">VCloud AI {{ sidebar ? "" : "Assistant" }}</span>
      </span>
    </h2>

    <div class="d-flex flex-row justify-content-between align-items-start px-3 header-actions">
      @if (viewType === "default" && (responses?.length ?? 0) > 1) {
        <button tooltip="Reset conversation" class="btn clickable m-1" (click)="clearConversation()">
          <app-vficon class="clickable" size="20px" iconPack="source-system-icons" iconName="refresh"></app-vficon>
        </button>
      }

      @if (viewType === "default") {
        <button
          [class.clickable]="!loading"
          tooltip="Customize"
          class="btn clickable ai-customise m-1"
          (click)="switchToUserPreferencesView()"
        >
          <app-vficon
            [class.clickable]="!loading"
            size="20px"
            iconPack="source-system-icons"
            iconName="settings"
          ></app-vficon>
        </button>
      }

      @if (sidebar && viewType === "default") {
        <button tooltip="Close" class="btn clickable m-1" (click)="closeLLM.emit(true)">
          <app-vficon size="20px" iconPack="source-system-icons" iconName="close"></app-vficon>
        </button>
      }
    </div>
  </div>

  @if (viewType === "configure") {
    <form
      [formGroup]="configureForm"
      (ngSubmit)="submitUserPreferences()"
      class="p-4 d-flex flex-column justify-content-start align-items-center"
    >
      <div class="mt-4">
        <label class="d-block">Preferred Cloud Provider(s)</label>
        <input formControlName="cloudProvider" type="text" placeholder="e.g. AWS" style="width: 30rem" />
      </div>

      <div class="mt-4">
        <label class="d-block">Your Role(s)</label>
        <input formControlName="role" placeholder="e.g. data engineer" type="text" style="width: 30rem" />
      </div>

      <div class="mt-4">
        <label class="d-block">Your Goal(s)</label>
        <input
          formControlName="goals"
          type="text"
          placeholder="e.g. understanding cost consumption"
          style="width: 30rem"
        />
      </div>

      <div class="mt-4">
        <label class="d-block">Your Application(s)</label>
        <input
          formControlName="application"
          type="text"
          placeholder="e.g. e-commerce angular application"
          style="width: 30rem"
        />
      </div>

      <div class="mt-4">
        <label class="d-block">Additional Instructions</label>
        <input
          formControlName="instructions"
          type="text"
          placeholder="e.g. please respond in a concise way"
          style="width: 30rem"
        />
      </div>

      <div class="d-flex mt-4">
        <button class="btn clickable btn-primary" type="submit">Save</button>
        <button class="btn clickable btn-secondary ms-2" type="button" (click)="resetForm()">Reset</button>
      </div>
    </form>
  }

  <app-user-permissions-summary></app-user-permissions-summary>

  @if (viewType === "default") {
    <ol class="list-unstyled d-block mx-auto mt-{{ sidebar ? 3 : 5 }}">
      <ng-container *ngFor="let r of responses; index as idx">
        @if (r?.type === "text" || r?.type === "error" || r?.type === "api_data") {
          <li
            [ngClass]="{
              'data-card': r?.type === 'api_data',
              'message-card': r?.type === 'text' || r?.type === 'error',
              'user-card': r?.who === 'User',
              'system-card': r?.who !== 'User',
            }"
            class="w-100 llm-response position-relative h5 mb-5 rounded custom-card"
          >
            <p
              style
              class="fw-bold py-2 px-3 d-flex flex-row justify-content-between align-items-center flex-nowrap m-0 mb-2 bg-{{
                r.who === 'User' ? 'light' : 'light'
              }}"
            >
              <span class="d-flex align-items-center mb-2">
                @if (r?.who === AI_NAME) {
                  <app-vficon
                    class="me-2 clickable"
                    iconName="default"
                    iconPack="source-tobi-icons"
                    size="25px"
                  ></app-vficon>
                }
                @if (r?.who === "User") {
                  <app-vficon
                    iconName="talk"
                    size="25px"
                    iconPack="source-mid-render-light-icons"
                    class="me-2 clickable"
                  ></app-vficon>
                }
                <span
                  [class.clickable]="r.who === 'VCloudSmart API'"
                  [tooltip]="TOOLTIPS[r.who]"
                  class="h4 position-relative"
                  style="top: 4px"
                  container="body"
                  >{{ sidebar ? r?.who.split(" ").slice(-1)[0] : r?.who }}</span
                >
              </span>
              <span>
                @for (ft of r.filterTags ?? []; track $index) {
                  <span class="btn btn-success clickable tag d-none {{ sidebar ? '' : 'd-md-inline' }}">
                    {{ ft }}
                  </span>
                }

                @if (r.analysing) {
                  <span class="btn btn-info clickable tag d-none {{ sidebar ? '' : 'd-md-inline' }}">
                    Analysing...
                  </span>
                }

                @if (r.limitFmt) {
                  <span class="btn btn-warning clickable tag d-none {{ sidebar ? '' : 'd-md-inline' }}">
                    Limit: {{ r.limitFmt }}
                  </span>
                }

                @if (r.dateRange) {
                  <span class="btn d-none d-sm-inline btn-success clickable tag">
                    {{ r.dateRange }}
                  </span>
                }

                @if (!sidebar) {
                  @for (csp of r.cloudProviders ?? []; track $index) {
                    <span
                      class="btn btn-warning clickable tag d-none d-md-inline"
                      tooltip="Change to another cloud provider"
                      [class.clickable]="
                        (r?.queryTypes ?? []).includes('api_payload') ||
                        (r?.queryTypes ?? []).includes('casual_interactions')
                      "
                      (click)="changeUserQueryCloudProvider(r, csp, idx)"
                    >
                      {{ csp | uppercase }}
                    </span>
                  }
                }

                @for (d of r.domains ?? []; track $index) {
                  <span
                    [class.clickable]="
                      (r?.queryTypes ?? []).includes('api_payload') ||
                      (r?.queryTypes ?? []).includes('casual_interactions')
                    "
                    [class.d-md-inline]="!sidebar"
                    class="btn btn-primary tag d-none"
                    tooltip="Click to switch to a different domain"
                    (click)="
                      (r?.queryTypes ?? []).includes('casual_interactions') ||
                      (r?.queryTypes ?? []).includes('api_payload')
                        ? changeUserQueryDomain(r, d, idx)
                        : null
                    "
                    [ngSwitch]="d"
                    container="body"
                  >
                    {{ d }}
                  </span>
                }

                @for (qt of r.queryTypes ?? []; track $index) {
                  <span
                    (click)="changeUserQueryType(r, qt, idx)"
                    [tooltip]="qt === 'casual_interactions' ? 'Get data instead' : 'Ask question instead'"
                    class="btn btn-secondary clickable tag d-none d-sm-inline"
                    container="body"
                  >
                    @switch (qt) {
                      @case ("api_payload") {
                        <ng-container>request for data</ng-container>
                      }
                      @case ("casual_interactions") {
                        <ng-container>question</ng-container>
                      }
                      @case ("suggest_reports") {
                        <ng-container>which page?</ng-container>
                      }
                    }
                  </span>
                }

                @if (r.type === "text" || r.type === "error" || r.type === "api_data") {
                  <app-vficon
                    size="20px"
                    (click)="copy(r)"
                    tooltip="Copy"
                    class="me-2 clickable"
                    style="position: relative; bottom: 3px"
                    iconPack="source-system-icons"
                    iconName="copy"
                    container="body"
                  ></app-vficon>
                }

                @if (r?.who === "User" && !r.isEditable) {
                  <app-vficon
                    size="25px"
                    tooltip="Edit"
                    (click)="editUserQuery(idx, r)"
                    [class.disabled]="!!loading"
                    [class.clickable]="!loading"
                    class="me-2"
                    style="position: relative; bottom: 3px"
                    iconPack="source-system-icons"
                    iconName="edit"
                    container="body"
                  ></app-vficon>
                }

                @if (r?.who === "User" && r.isEditable) {
                  <app-vficon
                    size="25px"
                    (click)="editUserQuery(idx, r)"
                    [class.clickable]="!loading"
                    tooltip="Save"
                    [class.disabled]="!!loading"
                    class="me-2"
                    style="position: relative; bottom: 3px"
                    iconPack="source-system-icons"
                    iconName="tick"
                    container="body"
                  ></app-vficon>
                }

                @if (r?.who === "User") {
                  <app-vficon
                    size="25px"
                    (click)="retryUserQuery(idx, r)"
                    [class.clickable]="!loading"
                    [class.disabled]="!!loading"
                    class="me-3"
                    style="position: relative; bottom: 3px"
                    tooltip="Retry"
                    iconPack="source-system-icons"
                    iconName="refresh"
                    container="body"
                  ></app-vficon>
                }

                @if (idx > 0 && r?.who === "User" && !sidebar) {
                  <app-vficon
                    size="25px"
                    (click)="removeResponseFromConversation(idx)"
                    [class.clickable]="!loading"
                    [class.disabled]="!!loading"
                    class="me-0"
                    style="position: relative; bottom: 3px"
                    iconPack="source-system-icons"
                    tooltip="Remove bubble"
                    iconName="close"
                    container="body"
                  ></app-vficon>
                }

                @if (r?.who !== "User") {
                  <button
                    class="btn clickable"
                    (click)="r.collapsed = !r.collapsed"
                    [disabled]="!!loading"
                    [class.disabled]="!!loading"
                  >
                    @switch (!!r?.collapsed) {
                      @case (false) {
                        <app-vficon
                          size="25px"
                          class="clickable"
                          style="position: relative; bottom: 3px"
                          iconPack="source-system-icons"
                          tooltip="Collapse"
                          iconName="chevron-down"
                          container="body"
                        ></app-vficon>
                      }
                      @case (true) {
                        <app-vficon
                          size="25px"
                          class="clickable"
                          tooltip="Expand"
                          style="position: relative; bottom: 3px"
                          iconPack="source-system-icons"
                          iconName="chevron-up"
                          container="body"
                        ></app-vficon>
                      }
                    }
                  </button>
                }
              </span>
            </p>

            @if (!r?.collapsed) {
              <div class="p-3">
                @if (r?.type === "api_data") {
                  <ul class="nav nav-tabs d-flex flex-row justify-content-center mb-5 pcs-nav-tabs">
                    @if (canDisplayColumnChart(r)) {
                      <li class="nav-item px-0 py-1 me-1 {{ shouldDisplayColumnChart(r) ? 'active disabled' : '' }}">
                        <button
                          class="nav-link px-0 clickable {{ shouldDisplayColumnChart(r) ? ' active disabled ' : '' }}"
                          (click)="handleSelectTab(r, 'Column Chart')"
                          [attr.data-header-type]="'Column Chart'"
                        >
                          Column Chart
                        </button>
                      </li>
                    }
                    @if (canDisplayPieChart(r)) {
                      <li class="nav-item {{ shouldDisplayPieChart(r) ? 'active disabled' : '' }}">
                        <button
                          class="nav-link clickable {{ shouldDisplayPieChart(r) ? ' active disabled ' : '' }}"
                          (click)="handleSelectTab(r, 'Pie Chart')"
                          [attr.data-header-type]="'Pie Chart'"
                        >
                          Pie Chart
                        </button>
                      </li>
                    }
                    @if (canDisplayTable(r)) {
                      <li class="nav-item {{ shouldDisplayTable(r) ? ' active disabled ' : '' }}">
                        <button
                          class="nav-link clickable {{ shouldDisplayTable(r) ? 'active disabled' : '' }}"
                          (click)="handleSelectTab(r, 'Table')"
                          [attr.data-header-type]="
                            r?.tableRows?.length === 1 && r?.tableColumns?.length === 1 ? 'Result' : 'Table'
                          "
                        >
                          {{ r?.tableRows?.length === 1 && r?.tableColumns?.length === 1 ? "Result" : "Table" }}
                        </button>
                      </li>
                    }
                    @if (canDisplayPayload(r)) {
                      <li class="nav-item {{ shouldDisplayPayload(r) ? 'active disabled' : '' }}">
                        <button
                          class="nav-link clickable {{ shouldDisplayPayload(r) ? ' active disabled ' : '' }}"
                          (click)="handleSelectTab(r, 'Payload')"
                        >
                          API Payload
                        </button>
                      </li>
                    }
                  </ul>

                  @if (shouldDisplayPayload(r)) {
                    <p
                      class="ms-{{ sidebar ? 1 : 5 }}"
                      style="white-space: pre; font-family: monospace; font-size: 1rem; overflow: scroll"
                    >
                      {{ JSON.stringify(r.payload, null, sidebar ? 2 : 4) }}
                    </p>
                  } @else {
                    @if (r?.tableRows?.length === 0 || r?.tableColumns?.length === 0) {
                      <p class="text-center mx-auto">No matching data could be found.</p>
                    } @else {
                      @if (shouldDisplayPieChart(r) || shouldDisplayColumnChart(r)) {
                        <google-chart
                          (error)="handleChartError(r)"
                          [type]="shouldDisplayPieChart(r) ? 'PieChart' : 'ColumnChart'"
                          [options]="
                            shouldDisplayColumnChart(r)
                              ? (r?.columnChartOptions ?? columnChartOptions)
                              : (r?.pieChartOptions ?? pieChartOptions)
                          "
                          style="width: 100%"
                          class="mb-0"
                          [dynamicResize]="true"
                          [columns]="r?.chartColumns ?? []"
                          (select)="drillDown($event, r)"
                          [data]="r?.chartRows ?? []"
                        ></google-chart>
                      }

                      @if (r?.tableRows?.length >= ROWS_PER_PAGE) {
                        <p class="text-danger text-center m-0 mb-2 mt-1">
                          <strong>WARNING</strong>: response may have been truncated to the first
                          {{ looker.formatNumber(Math.max(ROWS_PER_PAGE, r?.tableRows?.length ?? 0)).fmt }} rows. Click

                          <button (click)="fetchNextPage(r)" class="btn clickable btn-link p-0 m-0">here</button>
                          to fetch next page.
                        </p>
                      }

                      @if (shouldDisplayTable(r)) {
                        <app-common-table
                          [tableName]="getTableName(r, idx)"
                          [columns]="r?.tableColumns ?? []"
                          [rows]="r?.tableRows ?? []"
                          [downloadRequestBody]="r.payload"
                          [inputFilters]="r?.tableFilters ?? []"
                          [showFilterAccordion]="(r?.tableRows?.length ?? 0) > 5"
                          (filtersChanged)="r.tableFilters = $event"
                          [showColumnSelectAccordion]="(r?.tableColumns?.length ?? 0) > 3"
                          [loading]="false"
                          [exactRows]="r?.tableRows?.length ?? 0"
                          [pageSize]="5"
                        ></app-common-table>
                      }
                    }
                  }
                }

                @if (!r?.isEditable && (r?.type === "error" || r?.type === "text")) {
                  <div [innerHTML]="r?.message" class="w-100 d-inline generatedHtml"></div>
                }

                @if (
                  !!r?.messageId &&
                  !(r?.isEditable ?? false) &&
                  (r?.who === AI_NAME || r.who === "VCloudSmart API") &&
                  (r?.type === "error" || r?.type === "text" || r?.type === "api_data")
                ) {
                  <ng-container>
                    <hr />
                    <p class="m-0 p-0">
                      @if (!r?.ratingProvided) {
                        Rate this response:
                        <app-vficon
                          class="clickable position-relative ms-2"
                          (click)="triggerRatingPopUp(ratingTemplate, r.messageId)"
                          style="bottom: 3px"
                          size="20px"
                          iconPack="source-system-icons"
                          iconName="like"
                        ></app-vficon>
                      } @else {
                        We received your feedback. Thanks!
                      }
                    </p>
                  </ng-container>
                }

                @if (r.isEditable && r?.type === "text" && r.who === "User") {
                  <textarea [(ngModel)]="r.message" class="w-100 d-inline"></textarea>
                }
              </div>
            }
          </li>
        }
      </ng-container>
    </ol>
  }

  @if (!loading && viewType === "default") {
    <div
      class="{{
        sidebar
          ? 'd-flex flex-column align-items-center justify-content-start p-0 mt-5'
          : 'd-flex flex-column flex-xl-row align-items-center align-items-xl-start justify-content-start justify-content-xl-center p-0 mt-5'
      }}"
    >
      @if ((suggestedURLs?.length ?? 0) > 0) {
        <div class="{{ sidebar ? 'mb-4' : 'me-4' }}">
          <h3 class="h3 text-center">Related Reports</h3>
          <ul
            class="{{
              sidebar
                ? 'list-unstyled d-flex mx-auto flex-column flex-nowrap align-items-center mt-4'
                : 'list-unstyled d-flex mx-auto flex-column flex-md-row flex-nowrap justify-content-md-start align-items-center mt-4'
            }}"
          >
            @for (e of suggestedURLs; track $index) {
              <li
                class="ms-4 d-flex flex-column justify-content-between align-items-start mb-2 p-4 custom-card links-card system-card"
                style="width: 18rem; height: 11rem"
              >
                <div>
                  <h4 class="h4">
                    {{ prettify(decodeURIComponent(e?.Name)) }}
                  </h4>
                  <h5 class="h5">
                    {{ e?.CloudProvider ?? "" | uppercase }} {{ prettify(decodeURIComponent(e?.Section ?? "")) }}
                  </h5>
                </div>
                <a
                  class="btn btn-primary clickable"
                  [fragment]="e?.Fragment"
                  [queryParams]="e?.Query"
                  [routerLink]="(e?.URL ?? '').replace('%28', '(').replace('%29', ')')"
                  >Explore</a
                >
              </li>
            }
          </ul>
        </div>
      }

      @if ((exampleQuestions?.length ?? 0) > 0) {
        <div class="suggested-questions">
          <div class="d-flex flex-row justify-content-between flex-nowrap">
            <span style="width: 2.5rem"></span>
            <h3 class="h3 text-center">Suggested Questions</h3>
            <button
              tooltip="Reload example questions"
              (click)="retryPotentialQuestions()"
              [class.clickable]="!loading && !loadingV2.has('potential_questions')"
              class="btn"
              style="width: 2.5rem"
            >
              <app-vficon
                [class.clickable]="!loading && !loadingV2.has('potential_questions')"
                size="20px"
                iconPack="source-system-icons"
                iconName="refresh"
              ></app-vficon>
            </button>
          </div>
          <ul
            class="list-unstyled d-flex mx-auto flex-column flex-nowrap justify-content-start align-items-center mt-4"
          >
            @for (e of exampleQuestions; track $index) {
              <li class="w-100 mb-2">
                <button
                  [disabled]="!!loading"
                  (click)="submitUserQuery(e, MODEL_CHEAP)"
                  class="d-block h4 custom-button clickable w-100"
                  [innerHTML]="e"
                ></button>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  }

  @if (!!loading) {
    <div>
      <img
        style="height: 100px"
        id="vf-loader"
        class="d-block m-auto"
        src="/assets/images/spinner_logo.svg"
        alt="spinner"
      />
      <p class="text-center mt-3">
        @switch (loading) {
          @case ("analyse_query") {
            <ng-container>Determining query type...</ng-container>
          }
          @case ("suggested_reports") {
            <ng-container>
              Determining query type ✓<br />
              Suggesting relevant reports...
            </ng-container>
          }
          @case ("generated_api_payload") {
            <ng-container>
              Determining query type ✓<br />
              Generating query...
            </ng-container>
          }
          @case ("api_data") {
            <ng-container>
              Determining query type ✓<br />
              Generating query ✓<br />
              Getting data...
            </ng-container>
          }
          @case ("potential_questions") {
            <ng-container>Suggesting questions...</ng-container>
          }
          @case ("text") {
            <ng-container>
              Determining query type ✓<br />
              Interpreting...
            </ng-container>
          }
          @case ("user_info") {
            <ng-container>Getting user info...</ng-container>
          }
          @default {
            <ng-container>Processing...</ng-container>
          }
        }
      </p>
    </div>
  }

  @if (viewType === "default") {
    <form class="p-0 m-0">
      <div class="textarea-wrapper">
        <textarea
          placeholder="e.g. What is my cost consumption in AWS for the past 6 months?"
          class="custom-textarea"
          [rows]="sidebar ? 2 : 1"
          [disabled]="!!loading"
          [class.disabled]="!!loading"
          [(ngModel)]="userQuery"
          [ngModelOptions]="{ standalone: true }"
          (input)="onTextareaInput($event)"
          (keydown)="onTextareaKeydown($event, userQuery)"
        ></textarea>
        <button
          [class.invisible]="!!loading || !userQuery.trim()"
          [class.disabled]="!!loading || !userQuery.trim()"
          [class.clickable]="!loading && !!userQuery.trim()"
          (click)="submitUserQuery(userQuery, MODEL_CHEAP)"
          [disabled]="!!loading || !userQuery.trim()"
          type="submit"
          class="submit-button"
        >
          <app-vficon
            [class.clickable]="!loading && !!userQuery.trim()"
            style="position: relative; bottom: 4px"
            size="30px"
            iconPack="source-hifi-light-icons"
            iconName="arrow-up"
          ></app-vficon>
        </button>
      </div>
    </form>
  }
</div>

<ng-template #ratingTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">VCloud AI Response Feedback</h4>
    <button type="button" class="btn-close clickable close pull-right" aria-label="Close" (click)="closeRatingPopUp()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center px-4 pt-2 pb-0">
    <p class="h3 mb-2 p-0">Rating (required)</p>
    <rating (ngModelChange)="ratingApplied = true" class="d-block mx-auto mb-4" [(ngModel)]="rating" [max]="5"></rating>

    <p class="h3 mb-2 p-0">Comment (optional)</p>
    <textarea
      style="max-width: 80%"
      rows="4"
      cols="60"
      class="mx-auto d-block mb-4"
      [(ngModel)]="ratingFeedback"
    ></textarea>

    <div style="width: 210px" class="d-flex justify-content-around mx-auto">
      <button
        [ngClass]="{ disabled: !ratingApplied, clickable: ratingApplied }"
        style="width: 8.35rem"
        type="button"
        class="btn btn-primary"
        (click)="submitRating(ratingMessageId, rating, ratingFeedback)"
      >
        Submit
      </button>
      <button style="width: 8.35rem" type="button" class="btn btn-secondary clickable" (click)="closeRatingPopUp()">
        Close
      </button>
    </div>
  </div>

  <hr />
  <p class="small pe-3 pb-2 text-end">Response ID: {{ ratingMessageId }}</p>
</ng-template>
